module.exports = __webpack_public_path__ + "img/button_3.28145585.png";